import api from './api';
import ErrorHandler from './errorHandler';

class PrintTemplateCategoryService {
    async list() {
        try {
            const response = await api.get('/api/print-template-categories');
            return response;
        } catch (error) {
            throw ErrorHandler.handleError(error);
        }
    }

    async get(id) {
        try {
            const response = await api.get(`/api/print-template-categories/${id}`);
            return response;
        } catch (error) {
            throw ErrorHandler.handleError(error);
        }
    }

    async create(data) {
        try {
            const response = await api.post('/api/print-template-categories', data);
            return response;
        } catch (error) {
            throw ErrorHandler.handleError(error);
        }
    }

    async update(id, data) {
        try {
            const response = await api.put(`/api/print-template-categories/${id}`, data);
            return response;
        } catch (error) {
            throw ErrorHandler.handleError(error);
        }
    }

    // Pin/unpin a category in the user browser — only one can be pinned;
    // the backend unpins the rest when pinning a new one.
    async pin(id, pinned) {
        try {
            const response = await api.patch(`/api/print-template-categories/${id}/pin`, { pinned });
            return response;
        } catch (error) {
            throw ErrorHandler.handleError(error);
        }
    }

    async remove(id) {
        try {
            const response = await api.delete(`/api/print-template-categories/${id}`);
            return response;
        } catch (error) {
            throw ErrorHandler.handleError(error);
        }
    }
}

export default new PrintTemplateCategoryService();
